import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useCRUD from '../useCRUD';
import { QUERY_CACHE_TIME } from '../../constants';
import useAccount from './useAccount';

const usePositionsGroups = () => {
  const { accountId } = useAccount();

  const storeKey = ['positions-groups', accountId];
  const { isLoading, data } = useQuery(storeKey, () => api.fetchPositionsGroups({ accountId }), {
    enabled: !!accountId,
    cacheTime: QUERY_CACHE_TIME
  });

  const { addItem, editItem, deleteItem } = useCRUD(
    storeKey,
    {
      addApi: (positionsGroup) => api.addPositionsGroup({ accountId, positionsGroup }),
      editApi: ({ id, ...positionsGroup }) =>
        api.updatePositionsGroup({ accountId, positionsGroupId: id, positionsGroup }),
      deleteApi: ({ id }) => api.deletePositionsGroup({ accountId, positionGroupsId: id })
    },
    { refetchOnSuccessDelete: true }
  );

  return {
    isLoading,
    positionsGroups: data?.data || [],
    addPositionsGroup: addItem,
    deletePositionsGroup: deleteItem,
    editPositionsGroup: editItem
  };
};

export default usePositionsGroups;
